import { useState } from "react";
import {
  ANGULAR,
  CSS,
  HTML,
  NEXT,
  NUXT,
  REACT,
  SVELTE,
  VUE,
  HTMLRIGHT,
  CSSRIGHT,
  REACTRIGHT,
  SVELETERIGHT,
  VUERIGHT,
  ANGULARRIGHT,
  NEXTRIGHT,
  NUXTRIGHT,
  FRONTENDICON,
  BACKENDICON,
  MOBILEAPPICON,
  DATABASEICON,
  BLOCKCHAINICON,
  NODERIGHT,
  PYTHONRIGHT,
  RUSTRIGHT,
  GORIGHT,
  RUBYRIGHT,
  CRIGHT,
  CPLUSRIGHT,
  ANDROIDRIGHT,
  APPLERIGHT,
  FLUTTERRIGHT,
  PWARIGHT,
  MONGORIGHT,
  MYSQLRIGHT,
  ORACLERIGHT,
  POSTGRERIGHT,
  CASSANDRARIGHT,
  DYNAMORIGHT,
  SOLIDITYRIGHT,
  SMARTRIGHT,
  TRUFFLERIGHT,
  HARDHATRIGHT,
  HYPERLEADGERRIGHT,
  MIGRATIONRIGHT,
  GRANCHERIGHT,
  BROWNIERIGHT,
  LINEONE,
  LINETWO,
  NODE,
  PYTHON,
  RUST,
  GO,
  RUBY,
  C,
  CPLUS,
  JENKINS,
  GIT,
  CIRCLECI,
  ANSIBLE,
  CHEF,
  PUPPET,
  DOCKER,
  KUBERNETES,
  PROMETHEUS,
  GRAFANA,
  JIRA,
  MEMCACHE,
  REDIS,
  RABBITMQ,
  KAFKA,
  MICROSERVICE,
  ML,
  DL,
  NLP,
  COMPUTERVISION,
  REINFORCEMENT,
  TENSORFLOW,
  PYTORCH,
  KERAS,
  SCIKIT,
  OPENCV,
  AWS,
  AZURE,
  IBM,
  ORACLE,
  ALIBABA,
  DIGITALOCEAN,
  GOOGLECLOUD,
  FIGMA,
  SKETCH,
  ADOBEXD,
  PHOTOSHOP,
  ILLUSTRATOR,
  AFTEREFFECTS,
  BLENDER,
  SPLINE,
  MAYA,
  SELENIUM,
  TESTINGNG,
  CUCUMBER,
  APACHE,
  DEVOPSICON,
  AIICON,
  CLOUDICON,
  DESIGNICON,
  TESTINGICON,
  PHP,
  LARAVEL,
  REACTNATIVE,
  IONIC,
  OPENAI,
  GEMINI,
  PROTRACTOR,
  POSTMAN,
  FOGBUGZ,
  BURPSUITE,
  BOOTSTRAP,
} from "./techstackImg";

const LandingTechStack = () => {
  const [activeTab, setActiveTab] = useState("frontend");

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
  };

  const [activeSection, setActiveSection] = useState(null);

  const toggleSection = (section) => {
    setActiveSection(activeSection === section ? null : section);
  };

  return (
    <article className="primary__landing-content-container ">
      <div className="landing__top">
        <h3 className="landing__explore--subHeader">
          Scalable and Secure
          <div>
            With <span className="landing__subHeader-clr"> Advance Tech.</span>{" "}
          </div>
        </h3>
      </div>

      <div className="landing__techstack-wrapper">
        {/* frontend-bg-images */}
        <div className={`img-wrap${activeTab === "frontend" ? "active" : ""} `}>
          <div className="landing__techstack-bg-img techImg--one">
            <img
              src={HTML}
              alt="World's No.1 Blockchain Development Company"
              loading="lazy"
            />
          </div>
          <div className="landing__techstack-bg-img techImg--two">
            <img
              src={VUE}
              alt="World's No.1 Blockchain Development Company"
              loading="lazy"
            />
          </div>
          <div className="landing__techstack-bg-img techImg--three">
            <img
              src={NUXT}
              alt="World's No.1 Blockchain Development Company"
              loading="lazy"
            />
          </div>
          <div className="landing__techstack-bg-img techImg--four">
            <img
              src={CSS}
              alt="World's No.1 Blockchain Development Company"
              loading="lazy"
            />
          </div>
          <div className="landing__techstack-bg-img techImg--five">
            <img
              src={SVELTE}
              alt="World's No.1 Blockchain Development Company"
              loading="lazy"
            />
          </div>
          <div className="landing__techstack-bg-img techImg--six">
            <img
              src={NEXT}
              alt="World's No.1 Blockchain Development Company"
              loading="lazy"
            />
          </div>
          <div className="landing__techstack-bg-img techImg--seven">
            <img
              src={REACT}
              alt="World's No.1 Blockchain Development Company"
              loading="lazy"
            />
          </div>
          <div className="landing__techstack-bg-img techImg--eight">
            <img
              src={ANGULAR}
              alt="World's No.1 Blockchain Development Company"
              loading="lazy"
            />
          </div>
        </div>
        {/* backend-bg-images */}
        <div className={`img-wrap${activeTab === "backend" ? "active" : ""} `}>
          <div className="landing__techstack-bg-img techImgBk--one">
            <img
              src={NODE}
              alt="World's No.1 Blockchain Development Company"
              loading="lazy"
            />
          </div>
          <div className="landing__techstack-bg-img techImgBk--two">
            <img
              src={C}
              alt="World's No.1 Blockchain Development Company"
              loading="lazy"
            />
          </div>
          <div className="landing__techstack-bg-img techImgBk--three">
            <img
              src={RUST}
              alt="World's No.1 Blockchain Development Company"
              loading="lazy"
            />
          </div>
          <div className="landing__techstack-bg-img techImgBk--four">
            <img
              src={RUBY}
              alt="World's No.1 Blockchain Development Company"
              loading="lazy"
            />
          </div>
          <div className="landing__techstack-bg-img techImgBk--five">
            <img
              src={GO}
              alt="World's No.1 Blockchain Development Company"
              loading="lazy"
            />
          </div>
          <div className="landing__techstack-bg-img techImgBk--six">
            <img
              src={CPLUS}
              alt="World's No.1 Blockchain Development Company"
              loading="lazy"
            />
          </div>
          <div className="landing__techstack-bg-img techImgBk--seven">
            <img
              src={PYTHON}
              alt="World's No.1 Blockchain Development Company"
              loading="lazy"
            />
          </div>
        </div>
        {/* mobileapp-bg-images */}
        <div
          className={`img-wrap${activeTab === "mobileapp" ? "active" : ""} `}
        >
          <div className="landing__techstack-bg-img techImgmb--one">
            <img
              src={ANDROIDRIGHT}
              alt="World's No.1 Blockchain Development Company"
              loading="lazy"
            />
          </div>
          <div className="landing__techstack-bg-img techImgmb--two">
            <img
              src={APPLERIGHT}
              alt="World's No.1 Blockchain Development Company"
              loading="lazy"
            />
          </div>
          <div className="landing__techstack-bg-img techImgmb--three">
            <img
              src={PWARIGHT}
              alt="World's No.1 Blockchain Development Company"
              loading="lazy"
            />
          </div>
          <div className="landing__techstack-bg-img techImgmb--four">
            <img
              src={FLUTTERRIGHT}
              alt="World's No.1 Blockchain Development Company"
              loading="lazy"
            />
          </div>
        </div>
        {/* database-bg-images */}
        <div className={`img-wrap${activeTab === "database" ? "active" : ""} `}>
          <div className="landing__techstack-bg-img techImgdb--one">
            <img
              src={MONGORIGHT}
              alt="World's No.1 Blockchain Development Company"
              loading="lazy"
            />
          </div>
          <div className="landing__techstack-bg-img techImgdb--two">
            <img
              src={MYSQLRIGHT}
              alt="World's No.1 Blockchain Development Company"
              loading="lazy"
            />
          </div>
          <div className="landing__techstack-bg-img techImgdb--three">
            <img
              src={ORACLERIGHT}
              alt="World's No.1 Blockchain Development Company"
              loading="lazy"
            />
          </div>
          <div className="landing__techstack-bg-img techImgdb--four">
            <img
              src={POSTGRERIGHT}
              alt="World's No.1 Blockchain Development Company"
              loading="lazy"
            />
          </div>
          <div className="landing__techstack-bg-img techImgdb--five">
            <img
              src={CASSANDRARIGHT}
              alt="World's No.1 Blockchain Development Company"
              loading="lazy"
            />
          </div>
          <div className="landing__techstack-bg-img techImgdb--six">
            <img
              src={DYNAMORIGHT}
              alt="World's No.1 Blockchain Development Company"
              loading="lazy"
            />
          </div>
        </div>
        {/* blockchain-bg-images */}
        <div
          className={`img-wrap${activeTab === "blockchain" ? "active" : ""} `}
        >
          <div className="landing__techstack-bg-img techImgBc--one">
            <img
              src={SOLIDITYRIGHT}
              alt="World's No.1 Blockchain Development Company"
              loading="lazy"
            />
          </div>
          <div className="landing__techstack-bg-img techImgBc--two ">
            <img
              src={RUSTRIGHT}
              alt="World's No.1 Blockchain Development Company"
              loading="lazy"
            />
          </div>
          <div className="landing__techstack-bg-img techImgBc--four ">
            <img
              src={TRUFFLERIGHT}
              alt="World's No.1 Blockchain Development Company"
              loading="lazy"
            />
          </div>
          <div className="landing__techstack-bg-img techImgBc--five ">
            <img
              src={HARDHATRIGHT}
              alt="World's No.1 Blockchain Development Company"
              loading="lazy"
            />
          </div>
          <div className="landing__techstack-bg-img techImgBc--eight">
            <img
              src={GRANCHERIGHT}
              alt="World's No.1 Blockchain Development Company"
              loading="lazy"
            />
          </div>
          <div className="landing__techstack-bg-img techImgBc--nine">
            <img
              src={BROWNIERIGHT}
              alt="World's No.1 Blockchain Development Company"
              loading="lazy"
            />
          </div>
        </div>
        {/* devops-bg-images */}
        <div className={`img-wrap${activeTab === "devops" ? "active" : ""} `}>
          <div className="landing__techstack-bg-img techImgDevops--one">
            <img
              src={JENKINS}
              alt="World's No.1 Blockchain Development Company"
              loading="lazy"
            />
          </div>
          <div className="landing__techstack-bg-img techImgDevops--two">
            <img
              src={GIT}
              alt="World's No.1 Blockchain Development Company"
              loading="lazy"
            />
          </div>
          <div className="landing__techstack-bg-img techImgDevops--three">
            <img
              src={CIRCLECI}
              alt="World's No.1 Blockchain Development Company"
              loading="lazy"
            />
          </div>
          <div className="landing__techstack-bg-img techImgDevops--four">
            <img
              src={KUBERNETES}
              alt="World's No.1 Blockchain Development Company"
              loading="lazy"
            />
          </div>
          <div className="landing__techstack-bg-img techImgDevops--five">
            <img
              src={PUPPET}
              alt="World's No.1 Blockchain Development Company"
              loading="lazy"
            />
          </div>
          <div className="landing__techstack-bg-img techImgDevops--six">
            <img
              src={ANSIBLE}
              alt="World's No.1 Blockchain Development Company"
              loading="lazy"
            />
          </div>
          <div className="landing__techstack-bg-img techImgDevops--seven">
            <img
              src={DOCKER}
              alt="World's No.1 Blockchain Development Company"
              loading="lazy"
            />
          </div>
        </div>
        {/* AI-bg-images */}
        <div className={`img-wrap${activeTab === "ai" ? "active" : ""} `}>
          <div className="landing__techstack-bg-img techImgBc--one">
            <img
              src={KERAS}
              alt="World's No.1 Blockchain Development Company"
              loading="lazy"
            />
          </div>
          <div className="landing__techstack-bg-img techImgBc--two ">
            <img
              src={PYTORCH}
              alt="World's No.1 Blockchain Development Company"
              loading="lazy"
            />
          </div>
          <div className="landing__techstack-bg-img techImgBc--four ">
            <img
              src={COMPUTERVISION}
              alt="World's No.1 Blockchain Development Company"
              loading="lazy"
            />
          </div>
          <div className="landing__techstack-bg-img techImgBc--five ">
            <img
              src={TENSORFLOW}
              alt="World's No.1 Blockchain Development Company"
              loading="lazy"
            />
          </div>
          <div className="landing__techstack-bg-img techImgBc--eight">
            <img
              src={OPENCV}
              alt="World's No.1 Blockchain Development Company"
              loading="lazy"
            />
          </div>
          <div className="landing__techstack-bg-img techImgBc--nine">
            <img
              src={SCIKIT}
              alt="World's No.1 Blockchain Development Company"
              loading="lazy"
            />
          </div>
        </div>
        {/* cloud-bg-images */}
        <div className={`img-wrap${activeTab === "cloud" ? "active" : ""} `}>
          <div className="landing__techstack-bg-img techImg--one techImgCl--one">
            <img
              src={AWS}
              alt="World's No.1 Blockchain Development Company"
              loading="lazy"
            />
          </div>
          <div className="landing__techstack-bg-img techImg--two techImgCl--two">
            <img
              src={IBM}
              alt="World's No.1 Blockchain Development Company"
              loading="lazy"
            />
          </div>
          <div className="landing__techstack-bg-img techImg--three techImgCl--three">
            <img
              src={GOOGLECLOUD}
              alt="World's No.1 Blockchain Development Company"
              loading="lazy"
            />
          </div>
          <div className="landing__techstack-bg-img techImg--four techImgCl--four">
            <img
              src={AZURE}
              alt="World's No.1 Blockchain Development Company"
              loading="lazy"
            />
          </div>
          <div className="landing__techstack-bg-img techImg--five techImgCl--five">
            <img
              src={ALIBABA}
              alt="World's No.1 Blockchain Development Company"
              loading="lazy"
            />
          </div>
          <div className="landing__techstack-bg-img techImg--six techImgCl--six">
            <img
              src={DIGITALOCEAN}
              alt="World's No.1 Blockchain Development Company"
              loading="lazy"
            />
          </div>
          <div className="landing__techstack-bg-img techImg--seven techImgCl--seven">
            <img
              src={ORACLE}
              alt="World's No.1 Blockchain Development Company"
              loading="lazy"
            />
          </div>
        </div>
        {/* design-bg-images */}
        <div className={`img-wrap${activeTab === "design" ? "active" : ""} `}>
          <div className="landing__techstack-bg-img techImgBc--one">
            <img
              src={FIGMA}
              alt="World's No.1 Blockchain Development Company"
              loading="lazy"
            />
          </div>
          <div className="landing__techstack-bg-img techImgBc--two ">
            <img
              src={SKETCH}
              alt="World's No.1 Blockchain Development Company"
              loading="lazy"
            />
          </div>
          <div className="landing__techstack-bg-img techImgBc--four ">
            <img
              src={ADOBEXD}
              alt="World's No.1 Blockchain Development Company"
              loading="lazy"
            />
          </div>
          <div className="landing__techstack-bg-img techImgBc--five ">
            <img
              src={PHOTOSHOP}
              alt="World's No.1 Blockchain Development Company"
              loading="lazy"
            />
          </div>
          <div className="landing__techstack-bg-img techImgBc--eight">
            <img
              src={SPLINE}
              alt="World's No.1 Blockchain Development Company"
              loading="lazy"
            />
          </div>
          <div className="landing__techstack-bg-img techImgBc--nine">
            <img
              src={AFTEREFFECTS}
              alt="World's No.1 Blockchain Development Company"
              loading="lazy"
            />
          </div>
        </div>
        {/* testing-bg-images */}
        <div className={`img-wrap${activeTab === "testing" ? "active" : ""} `}>
          <div className="landing__techstack-bg-img techImgdb--one">
            <img
              src={SELENIUM}
              alt="World's No.1 Blockchain Development Company"
              loading="lazy"
            />
          </div>
          <div className="landing__techstack-bg-img techImgdb--two">
            <img
              src={TESTINGNG}
              alt="World's No.1 Blockchain Development Company"
              loading="lazy"
            />
          </div>
          <div className="landing__techstack-bg-img techImgdb--four">
            <img
              src={APACHE}
              alt="World's No.1 Blockchain Development Company"
              loading="lazy"
            />
          </div>
          <div className="landing__techstack-bg-img techImgdb--five">
            <img
              src={CUCUMBER}
              alt="World's No.1 Blockchain Development Company"
              loading="lazy"
            />
          </div>
        </div>

        <div className="landing__techstack-bg-img techImg--nine">
          <img
            src={LINEONE}
            alt="World's No.1 Blockchain Development Company"
            loading="lazy"
          />
        </div>
        <div className="landing__techstack-bg-img techImg--ten">
          <img
            src={LINETWO}
            alt="World's No.1 Blockchain Development Company"
            loading="lazy"
          />
        </div>

        <div className="landing__techstack-outer">
          {/* left */}
          <div className="landing__techstack-left">
            <ul className="landing__techstack-left-lists">
              <li
                className={`landing__techstack-left-links ${
                  activeTab === "frontend" ? "active" : ""
                }`}
                onClick={() => handleTabClick("frontend")}
              >
                <div className="landing__techstack-left-content-wrap">
                  <div>
                    <span>
                      <img
                        src={FRONTENDICON}
                        alt="World's No.1 Blockchain Development Company"
                        loading="lazy"
                      />
                    </span>
                    <span className="landing__techstack-left-content-title">
                      Frontend Technologies
                    </span>
                  </div>
                  <div
                    className={`tect-stack-arrow ${
                      activeTab === "frontend" ? "active" : ""
                    }`}
                  >
                    <i className="fa-solid fa-arrow-right"></i>
                  </div>
                </div>
              </li>
              <li
                className={`landing__techstack-left-links ${
                  activeTab === "backend" ? "active" : ""
                }`}
                onClick={() => handleTabClick("backend")}
              >
                {" "}
                <div className="landing__techstack-left-content-wrap">
                  <div>
                    <span>
                      <img
                        src={BACKENDICON}
                        alt="World's No.1 Blockchain Development Company"
                        loading="lazy"
                      />
                    </span>
                    <span className="landing__techstack-left-content-title">
                      Backend Technologies
                    </span>
                  </div>
                  <div
                    className={`tect-stack-arrow ${
                      activeTab === "backend" ? "active" : ""
                    }`}
                  >
                    <i className="fa-solid fa-arrow-right"></i>
                  </div>
                </div>
              </li>
              <li
                className={`landing__techstack-left-links ${
                  activeTab === "mobileapp" ? "active" : ""
                }`}
                onClick={() => handleTabClick("mobileapp")}
              >
                <div className="landing__techstack-left-content-wrap">
                  <div>
                    <span>
                      <img
                        src={MOBILEAPPICON}
                        alt="World's No.1 Blockchain Development Company"
                        loading="lazy"
                      />
                    </span>
                    <span className="landing__techstack-left-content-title">
                      Mobile App
                    </span>
                  </div>
                  <div
                    className={`tect-stack-arrow ${
                      activeTab === "mobileapp" ? "active" : ""
                    }`}
                  >
                    <i className="fa-solid fa-arrow-right"></i>
                  </div>
                </div>
              </li>
              <li
                className={`landing__techstack-left-links ${
                  activeTab === "database" ? "active" : ""
                }`}
                onClick={() => handleTabClick("database")}
              >
                <div className="landing__techstack-left-content-wrap">
                  <div>
                    <span>
                      <img
                        src={DATABASEICON}
                        alt="World's No.1 Blockchain Development Company"
                        loading="lazy"
                      />
                    </span>
                    <span className="landing__techstack-left-content-title">
                      Database
                    </span>
                  </div>
                  <div
                    className={`tect-stack-arrow ${
                      activeTab === "database" ? "active" : ""
                    }`}
                  >
                    <i className="fa-solid fa-arrow-right"></i>
                  </div>
                </div>
              </li>
              <li
                className={`landing__techstack-left-links ${
                  activeTab === "blockchain" ? "active" : ""
                }`}
                onClick={() => handleTabClick("blockchain")}
              >
                <div className="landing__techstack-left-content-wrap">
                  <div>
                    <span>
                      <img
                        src={BLOCKCHAINICON}
                        alt="World's No.1 Blockchain Development Company"
                        loading="lazy"
                      />
                    </span>
                    <span className="landing__techstack-left-content-title">
                      Blockchain
                    </span>
                  </div>
                  <div
                    className={`tect-stack-arrow ${
                      activeTab === "blockchain" ? "active" : ""
                    }`}
                  >
                    <i className="fa-solid fa-arrow-right"></i>
                  </div>
                </div>
              </li>

              <li
                className={`landing__techstack-left-links ${
                  activeTab === "devops" ? "active" : ""
                }`}
                onClick={() => handleTabClick("devops")}
              >
                <div className="landing__techstack-left-content-wrap">
                  <div>
                    <span>
                      <img
                        src={DEVOPSICON}
                        alt="World's No.1 Blockchain Development Company"
                        loading="lazy"
                      />
                    </span>
                    <span className="landing__techstack-left-content-title">
                      Devops
                    </span>
                  </div>
                  <div
                    className={`tect-stack-arrow ${
                      activeTab === "devops" ? "active" : ""
                    }`}
                  >
                    <i className="fa-solid fa-arrow-right"></i>
                  </div>
                </div>
              </li>
              <li
                className={`landing__techstack-left-links ${
                  activeTab === "ai" ? "active" : ""
                }`}
                onClick={() => handleTabClick("ai")}
              >
                <div className="landing__techstack-left-content-wrap">
                  <div>
                    <span>
                      <img
                        src={AIICON}
                        alt="World's No.1 Blockchain Development Company"
                        loading="lazy"
                      />
                    </span>
                    <span className="landing__techstack-left-content-title">
                      Artificial Intelligence
                    </span>
                  </div>
                  <div
                    className={`tect-stack-arrow ${
                      activeTab === "ai" ? "active" : ""
                    }`}
                  >
                    <i className="fa-solid fa-arrow-right"></i>
                  </div>
                </div>
              </li>
              <li
                className={`landing__techstack-left-links ${
                  activeTab === "cloud" ? "active" : ""
                }`}
                onClick={() => handleTabClick("cloud")}
              >
                <div className="landing__techstack-left-content-wrap">
                  <div>
                    <span>
                      <img
                        src={CLOUDICON}
                        alt="World's No.1 Blockchain Development Company"
                        loading="lazy"
                      />
                    </span>
                    <span className="landing__techstack-left-content-title">
                      Cloud Services
                    </span>
                  </div>
                  <div
                    className={`tect-stack-arrow ${
                      activeTab === "cloud" ? "active" : ""
                    }`}
                  >
                    <i className="fa-solid fa-arrow-right"></i>
                  </div>
                </div>
              </li>
              <li
                className={`landing__techstack-left-links ${
                  activeTab === "design" ? "active" : ""
                }`}
                onClick={() => handleTabClick("design")}
              >
                <div className="landing__techstack-left-content-wrap">
                  <div>
                    <span>
                      <img
                        src={DESIGNICON}
                        alt="World's No.1 Blockchain Development Company"
                        loading="lazy"
                      />
                    </span>
                    <span className="landing__techstack-left-content-title">
                      Design
                    </span>
                  </div>
                  <div
                    className={`tect-stack-arrow ${
                      activeTab === "design" ? "active" : ""
                    }`}
                  >
                    <i className="fa-solid fa-arrow-right"></i>
                  </div>
                </div>
              </li>
              <li
                className={`landing__techstack-left-links ${
                  activeTab === "testing" ? "active" : ""
                }`}
                onClick={() => handleTabClick("testing")}
              >
                <div className="landing__techstack-left-content-wrap">
                  <div>
                    <span>
                      <img
                        src={TESTINGICON}
                        alt="World's No.1 Blockchain Development Company"
                        loading="lazy"
                      />
                    </span>
                    <span className="landing__techstack-left-content-title">
                      Testing
                    </span>
                  </div>
                  <div
                    className={`tect-stack-arrow ${
                      activeTab === "testing" ? "active" : ""
                    }`}
                  >
                    <i className="fa-solid fa-arrow-right"></i>
                  </div>
                </div>
              </li>
            </ul>
          </div>

          {/*  right */}
          <div className="landing__techstack-right techstack-right-none">
            <div
              className="tools_rt_inner landing__techstack-right-lists"
              id="tools_rt_scroll"
            >
              {/* frontend */}
              <div
                id="frontend"
                className={`techstack_content ${
                  activeTab === "frontend" ? "active" : ""
                }`}
              >
                <div className="tools-accordion-body">
                  <div className="landing__techstack-right-img-wrapper">
                    <ul>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={HTMLRIGHT}
                            alt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>HTML</span>
                      </li>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={CSSRIGHT}
                            alt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>CSS</span>
                      </li>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={REACTRIGHT}
                            alt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>React.Js</span>
                      </li>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={SVELETERIGHT}
                            alt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>Svelte</span>
                      </li>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={VUERIGHT}
                            alt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>Vue.Js</span>
                      </li>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={ANGULARRIGHT}
                            alt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>Angular</span>
                      </li>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={NEXTRIGHT}
                            alt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>Next Js</span>
                      </li>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={NUXTRIGHT}
                            alt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>NUXT</span>
                      </li>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={BOOTSTRAP}
                            alt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>Bootstrap</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* backend */}
              <div
                id="backend"
                className={`techstack_content ${
                  activeTab === "backend" ? "active" : ""
                }`}
              >
                <div className="tools-accordion-body">
                  <div className="landing__techstack-right-img-wrapper">
                    <ul>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={NODERIGHT}
                            alt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>Node.Js</span>
                      </li>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={PYTHONRIGHT}
                            alt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>Python</span>
                      </li>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={RUSTRIGHT}
                            alt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>RUST</span>
                      </li>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={GORIGHT}
                            alt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>Golang</span>
                      </li>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={RUBYRIGHT}
                            alt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>RUBY</span>
                      </li>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={CRIGHT}
                            alt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>C</span>
                      </li>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={CPLUSRIGHT}
                            alt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>C++</span>
                      </li>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={PHP}
                            alt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>PHP</span>
                      </li>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={LARAVEL}
                            alt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>Laravel</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* mobileapp */}
              <div
                id="mobileapp"
                className={`techstack_content ${
                  activeTab === "mobileapp" ? "active" : ""
                }`}
              >
                <div className="tools-accordion-body">
                  <div className="landing__techstack-right-img-wrapper">
                    <ul>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={ANDROIDRIGHT}
                            alt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>Android</span>
                      </li>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={APPLERIGHT}
                            alt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>IOS</span>
                      </li>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={FLUTTERRIGHT}
                            alt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>Flutter</span>
                      </li>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={PWARIGHT}
                            alt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>PWA</span>
                      </li>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={REACTNATIVE}
                            altalt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>React Native</span>
                      </li>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={IONIC}
                            alt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>Ionic</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* database */}
              <div
                id="database"
                className={`techstack_content ${
                  activeTab === "database" ? "active" : ""
                }`}
              >
                <div className="tools-accordion-body">
                  <div className="landing__techstack-right-img-wrapper">
                    <ul>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={MONGORIGHT}
                            alt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>Mongo DB</span>
                      </li>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={MYSQLRIGHT}
                            alt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>MySQL</span>
                      </li>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={ORACLERIGHT}
                            alt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>Oracle</span>
                      </li>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={POSTGRERIGHT}
                            alt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>PostgreSQL</span>
                      </li>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={CASSANDRARIGHT}
                            alt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>Cassandra</span>
                      </li>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={DYNAMORIGHT}
                            alt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>DynamoDB</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* blockchain */}
              <div
                id="blockchain"
                className={`techstack_content ${
                  activeTab === "blockchain" ? "active" : ""
                }`}
              >
                <div className="tools-accordion-body">
                  <div className="landing__techstack-right-img-wrapper">
                    <ul>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={SOLIDITYRIGHT}
                            alt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>Solidity</span>
                      </li>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={RUSTRIGHT}
                            alt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>Rust</span>
                      </li>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={SMARTRIGHT}
                            alt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>Smart Contract</span>
                      </li>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={TRUFFLERIGHT}
                            alt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>Truffle</span>
                      </li>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={HARDHATRIGHT}
                            alt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>Hardhat</span>
                      </li>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={HYPERLEADGERRIGHT}
                            alt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>Hyperledger</span>
                      </li>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={MIGRATIONRIGHT}
                            alt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>Migration</span>
                      </li>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={GRANCHERIGHT}
                            alt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>Granche</span>
                      </li>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={BROWNIERIGHT}
                            alt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>Brownie</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* Devops */}
              <div
                id="devops"
                className={`techstack_content ${
                  activeTab === "devops" ? "active" : ""
                }`}
              >
                <div className="tools-accordion-body">
                  <div className="landing__techstack-right-img-wrapper">
                    <ul>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={DOCKER}
                            alt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>Docker</span>
                      </li>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={KUBERNETES}
                            alt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>Kubernetes</span>
                      </li>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={KAFKA}
                            alt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>Kafka</span>
                      </li>{" "}
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={RABBITMQ}
                            alt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>RabbitMQ</span>
                      </li>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={REDIS}
                            alt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>Redis</span>
                      </li>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={MEMCACHE}
                            alt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>MemCache</span>
                      </li>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={MICROSERVICE}
                            alt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>Microservices</span>
                      </li>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={JIRA}
                            alt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>Jira</span>
                      </li>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={ANSIBLE}
                            alt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>Ansible</span>
                      </li>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={JENKINS}
                            alt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>Jenkins</span>
                      </li>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={GIT}
                            alt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>Git</span>
                      </li>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={CIRCLECI}
                            alt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>CircleCI</span>
                      </li>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={CHEF}
                            alt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>Chef</span>
                      </li>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={PUPPET}
                            alt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>Puppet</span>
                      </li>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={PROMETHEUS}
                            alt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>Prometheus</span>
                      </li>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={GRAFANA}
                            alt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>Grafana</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* artificial intelligence */}
              <div
                id="ai"
                className={`techstack_content ${
                  activeTab === "ai" ? "active" : ""
                }`}
              >
                <div className="tools-accordion-body">
                  <div className="landing__techstack-right-img-wrapper">
                    <ul>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={ML}
                            altalt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>Machine Learning</span>
                      </li>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={DL}
                            altalt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>Deep learning</span>
                      </li>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={NLP}
                            alt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>NLP</span>
                      </li>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={COMPUTERVISION}
                            alt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>Computer Vision</span>
                      </li>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={REINFORCEMENT}
                            altalt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>Reinforcement Learning</span>
                      </li>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={TENSORFLOW}
                            alt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>TensorFlow</span>
                      </li>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={PYTORCH}
                            alt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>PyTorch</span>
                      </li>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={KERAS}
                            alt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>Keras</span>
                      </li>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={SCIKIT}
                            altalt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>Scikit-Learn</span>
                      </li>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={OPENCV}
                            alt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>OpenCV</span>
                      </li>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={OPENAI}
                            alt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>OpenAI</span>
                      </li>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={GEMINI}
                            alt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>Gemini</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* cloud services */}
              <div
                id="cloud"
                className={`techstack_content ${
                  activeTab === "cloud" ? "active" : ""
                }`}
              >
                <div className="tools-accordion-body">
                  <div className="landing__techstack-right-img-wrapper">
                    <ul>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={AWS}
                            alt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>AWS</span>
                      </li>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={DIGITALOCEAN}
                            alt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>DigitalOcean</span>
                      </li>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={AZURE}
                            altalt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>Microsoft Azure</span>
                      </li>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={IBM}
                            alt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>IBM</span>
                      </li>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={ORACLE}
                            alt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>Oracle</span>
                      </li>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={ALIBABA}
                            alt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>Alibaba</span>
                      </li>

                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={GOOGLECLOUD}
                            altalt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>Google Cloud</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* design */}
              <div
                id="design"
                className={`techstack_content ${
                  activeTab === "design" ? "active" : ""
                }`}
              >
                <div className="tools-accordion-body">
                  <div className="landing__techstack-right-img-wrapper">
                    <ul>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={FIGMA}
                            alt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>Figma</span>
                      </li>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={SKETCH}
                            alt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>Sketch</span>
                      </li>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={ADOBEXD}
                            alt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>Adobe XD</span>
                      </li>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={PHOTOSHOP}
                            altalt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>Adobe Photoshop</span>
                      </li>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={ILLUSTRATOR}
                            altalt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>Adobe Illustrator</span>
                      </li>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={BLENDER}
                            alt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>Blender</span>
                      </li>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={SPLINE}
                            alt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>Spline</span>
                      </li>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={MAYA}
                            alt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>Maya</span>
                      </li>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={AFTEREFFECTS}
                            altalt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>After Effects</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* testing */}
              <div
                id="testing"
                className={`techstack_content ${
                  activeTab === "testing" ? "active" : ""
                }`}
              >
                <div className="tools-accordion-body">
                  <div className="landing__techstack-right-img-wrapper">
                    <ul>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={SELENIUM}
                            alt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>Selenium</span>
                      </li>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={TESTINGNG}
                            alt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>TestNG</span>
                      </li>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={CUCUMBER}
                            alt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>Cucumber</span>
                      </li>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={APACHE}
                            altalt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>Apache JMeter</span>
                      </li>
                      {/* <li>
                        <div className="landing__techstack-right-img-outer">
                          <img src={POSTMAN} alt="World's No.1 Blockchain Development Company" loading="lazy" />
                        </div>
                        <span>Postman</span>
                      </li> */}
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={FOGBUGZ}
                            alt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>FogBugz</span>
                      </li>
                      <li>
                        <div className="landing__techstack-right-img-outer">
                          <img
                            src={BURPSUITE}
                            alt="World's No.1 Blockchain Development Company"
                            loading="lazy"
                          />
                        </div>
                        <span>Burp Suite</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* mobile accordian (It will visible max-width:690px) */}
          <div className="landing__techstack-right techstack-right-mobile">
            <div
              className="tools_rt_inner landing__techstack-right-lists"
              id="tools_rt_scroll"
            >
              <div id="frontend">
                <div
                  className="techstack__accordian"
                  onClick={() => toggleSection("frontend")}
                >
                  <div>
                    <span>
                      <img
                        src={FRONTENDICON}
                        alt="World's No.1 Blockchain Development Company"
                        loading="lazy"
                      />
                    </span>
                    <span className="landing__techstack-left-content-title">
                      Frontend Technologies
                    </span>
                  </div>
                </div>

                {activeSection === "frontend" && (
                  <div className="tools-accordion-body">
                    <div className="landing__techstack-right-img-wrapper">
                      <ul>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={HTMLRIGHT}
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>HTML</span>
                        </li>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={CSSRIGHT}
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>CSS</span>
                        </li>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={REACTRIGHT}
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>React.Js</span>
                        </li>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={SVELETERIGHT}
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>Svelte</span>
                        </li>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={VUERIGHT}
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>Vue.Js</span>
                        </li>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={ANGULARRIGHT}
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>Angular</span>
                        </li>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={NEXTRIGHT}
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>Next Js</span>
                        </li>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={NUXTRIGHT}
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>NUXT</span>
                        </li>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={BOOTSTRAP}
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>Bootstrap</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                )}
              </div>

              <div id="backend">
                <div
                  className="techstack__accordian"
                  onClick={() => toggleSection("backend")}
                >
                  <span>
                    <img
                      src={BACKENDICON}
                      alt="World's No.1 Blockchain Development Company"
                      loading="lazy"
                    />
                  </span>
                  <span className="landing__techstack-left-content-title">
                    Backend Technologies
                  </span>
                </div>

                {activeSection === "backend" && (
                  <div className="tools-accordion-body">
                    <div className="landing__techstack-right-img-wrapper">
                      <ul>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={NODERIGHT}
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>Node.Js</span>
                        </li>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={PYTHONRIGHT}
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>Python</span>
                        </li>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={RUSTRIGHT}
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>RUST</span>
                        </li>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={GORIGHT}
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>Golang</span>
                        </li>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={RUBYRIGHT}
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>RUBY</span>
                        </li>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={CRIGHT}
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>C</span>
                        </li>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={CPLUSRIGHT}
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>C++</span>
                        </li>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={PHP}
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>PHP</span>
                        </li>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={LARAVEL}
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>Laravel</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                )}
              </div>

              <div id="mobileapp">
                <div
                  className="techstack__accordian"
                  onClick={() => toggleSection("mobileapp")}
                >
                  <span>
                    <img
                      src={MOBILEAPPICON}
                      alt="World's No.1 Blockchain Development Company"
                      loading="lazy"
                    />
                  </span>
                  <span className="landing__techstack-left-content-title">
                    Mobile App
                  </span>
                </div>
                {activeSection === "mobileapp" && (
                  <div className="tools-accordion-body">
                    <div className="landing__techstack-right-img-wrapper">
                      <ul>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={ANDROIDRIGHT}
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>Android</span>
                        </li>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={APPLERIGHT}
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>IOS</span>
                        </li>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={FLUTTERRIGHT}
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>Flutter</span>
                        </li>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={PWARIGHT}
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>PWA</span>
                        </li>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={REACTNATIVE}
                              altalt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>React Native</span>
                        </li>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={IONIC}
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>Ionic</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                )}
              </div>

              <div id="database">
                <div
                  className="techstack__accordian"
                  onClick={() => toggleSection("database")}
                >
                  <span>
                    <img
                      src={DATABASEICON}
                      alt="World's No.1 Blockchain Development Company"
                    />
                  </span>
                  <span className="landing__techstack-left-content-title">
                    Database
                  </span>
                </div>

                {activeSection === "database" && (
                  <div className="tools-accordion-body">
                    <div className="landing__techstack-right-img-wrapper">
                      <ul>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={MONGORIGHT}
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>Mongo DB</span>
                        </li>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={MYSQLRIGHT}
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>MySQL</span>
                        </li>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={ORACLERIGHT}
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>Oracle</span>
                        </li>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={POSTGRERIGHT}
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>PostgreSQL</span>
                        </li>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={CASSANDRARIGHT}
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>Cassandra</span>
                        </li>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={DYNAMORIGHT}
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>DynamoDB</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                )}
              </div>

              <div id="blockchain">
                <div
                  className="techstack__accordian"
                  onClick={() => toggleSection("blockchain")}
                >
                  <span>
                    <img
                      src={BLOCKCHAINICON}
                      alt="World's No.1 Blockchain Development Company"
                    />
                  </span>
                  <span className="landing__techstack-left-content-title">
                    Blockchain
                  </span>
                </div>

                {activeSection === "blockchain" && (
                  <div className="tools-accordion-body">
                    <div className="landing__techstack-right-img-wrapper">
                      <ul>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={SOLIDITYRIGHT}
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>Solidity</span>
                        </li>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={RUSTRIGHT}
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>Rust</span>
                        </li>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={SMARTRIGHT}
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>Smart Contract</span>
                        </li>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={TRUFFLERIGHT}
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>Truffle</span>
                        </li>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={HARDHATRIGHT}
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>Hardhat</span>
                        </li>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={HYPERLEADGERRIGHT}
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>Hyperledger</span>
                        </li>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={MIGRATIONRIGHT}
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>Migration</span>
                        </li>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={GRANCHERIGHT}
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>Granche</span>
                        </li>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={BROWNIERIGHT}
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>Brownie</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                )}
              </div>

              <div id="devops">
                <div
                  className="techstack__accordian"
                  onClick={() => toggleSection("devops")}
                >
                  <span>
                    <img
                      src={DEVOPSICON}
                      alt="World's No.1 Blockchain Development Company"
                    />
                  </span>
                  <span className="landing__techstack-left-content-title">
                    Devops
                  </span>
                </div>

                {activeSection === "devops" && (
                  <div className="tools-accordion-body">
                    <div className="landing__techstack-right-img-wrapper">
                      <ul>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={DOCKER}
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>Docker</span>
                        </li>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={KUBERNETES}
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>Kubernetes</span>
                        </li>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={KAFKA}
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>Kafka</span>
                        </li>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={RABBITMQ}
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>RabbitMQ</span>
                        </li>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={REDIS}
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>Redis</span>
                        </li>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={MEMCACHE}
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>MemCache</span>
                        </li>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={MICROSERVICE}
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>Microservices</span>
                        </li>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={JIRA}
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>Jira</span>
                        </li>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={ANSIBLE}
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>Ansible</span>
                        </li>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={JENKINS}
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>Jenkins</span>
                        </li>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={GIT}
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>Git</span>
                        </li>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={CIRCLECI}
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>CircleCI</span>
                        </li>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={CHEF}
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>Chef</span>
                        </li>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={PUPPET}
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>Puppet</span>
                        </li>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={PROMETHEUS}
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>Prometheus</span>
                        </li>{" "}
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={GRAFANA}
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>Grafana</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                )}
              </div>

              <div id="ai">
                <div
                  className="techstack__accordian"
                  onClick={() => toggleSection("ai")}
                >
                  <span>
                    <img
                      src={AIICON}
                      alt="World's No.1 Blockchain Development Company"
                    />
                  </span>
                  <span className="landing__techstack-left-content-title">
                    Artificial Intelligence
                  </span>
                </div>

                {activeSection === "ai" && (
                  <div className="tools-accordion-body">
                    <div className="landing__techstack-right-img-wrapper">
                      <ul>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={ML}
                              altalt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>Machine Learning</span>
                        </li>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={DL}
                              altalt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>Deep learning</span>
                        </li>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={NLP}
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>NLP</span>
                        </li>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={COMPUTERVISION}
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>Computer Vision</span>
                        </li>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={REINFORCEMENT}
                              altalt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>Reinforcement Learning</span>
                        </li>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={TENSORFLOW}
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>TensorFlow</span>
                        </li>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={PYTORCH}
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>PyTorch</span>
                        </li>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={KERAS}
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>Keras</span>
                        </li>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={SCIKIT}
                              altalt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>Scikit-Learn</span>
                        </li>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={OPENCV}
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>OpenCV</span>
                        </li>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={OPENAI}
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>OpenAI</span>
                        </li>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={GEMINI}
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>Gemini</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                )}
              </div>

              <div id="cloud">
                <div
                  className="techstack__accordian"
                  onClick={() => toggleSection("cloud")}
                >
                  <span>
                    <img
                      src={CLOUDICON}
                      alt="World's No.1 Blockchain Development Company"
                    />
                  </span>
                  <span className="landing__techstack-left-content-title">
                    Cloud Services
                  </span>
                </div>

                {activeSection === "cloud" && (
                  <div className="tools-accordion-body">
                    <div className="landing__techstack-right-img-wrapper">
                      <ul>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={AWS}
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>AWS</span>
                        </li>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={DIGITALOCEAN}
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>DigitalOcean</span>
                        </li>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={AZURE}
                              altalt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>Microsoft Azure</span>
                        </li>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={IBM}
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>IBM</span>
                        </li>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={ORACLE}
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>Oracle</span>
                        </li>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={ALIBABA}
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>Alibaba</span>
                        </li>

                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={GOOGLECLOUD}
                              altalt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>Google Cloud</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                )}
              </div>

              <div id="design">
                <div
                  className="techstack__accordian"
                  onClick={() => toggleSection("design")}
                >
                  <span>
                    <img
                      src={DESIGNICON}
                      alt="World's No.1 Blockchain Development Company"
                    />
                  </span>
                  <span className="landing__techstack-left-content-title">
                    Design
                  </span>
                </div>

                {activeSection === "design" && (
                  <div className="tools-accordion-body">
                    <div className="landing__techstack-right-img-wrapper">
                      <ul>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={FIGMA}
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>Figma</span>
                        </li>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={SKETCH}
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>Sketch</span>
                        </li>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={ADOBEXD}
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>Adobe XD</span>
                        </li>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={PHOTOSHOP}
                              altalt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>Adobe Photoshop</span>
                        </li>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={ILLUSTRATOR}
                              altalt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>Adobe Illustrator</span>
                        </li>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={BLENDER}
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>Blender</span>
                        </li>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={SPLINE}
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>Spline</span>
                        </li>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={MAYA}
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>Maya</span>
                        </li>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={AFTEREFFECTS}
                              altalt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>After Effects</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                )}
              </div>

              <div id="testing">
                <div
                  className="techstack__accordian"
                  onClick={() => toggleSection("testing")}
                >
                  <span>
                    <img
                      src={TESTINGICON}
                      alt="World's No.1 Blockchain Development Company"
                    />
                  </span>
                  <span className="landing__techstack-left-content-title">
                    Testing
                  </span>
                </div>

                {activeSection === "testing" && (
                  <div className="tools-accordion-body">
                    <div className="landing__techstack-right-img-wrapper">
                      <ul>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={SELENIUM}
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>Selenium</span>
                        </li>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={TESTINGNG}
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>TestNG</span>
                        </li>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={CUCUMBER}
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>Cucumber</span>
                        </li>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={APACHE}
                              altalt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>Apache JMeter</span>
                        </li>
                        {/* <li>
                          <div className="landing__techstack-right-img-outer">
                            <img src={POSTMAN} alt="World's No.1 Blockchain Development Company" loading="lazy" />
                          </div>
                          <span>Postman</span>
                        </li> */}
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={FOGBUGZ}
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>FogBugz</span>
                        </li>
                        <li>
                          <div className="landing__techstack-right-img-outer">
                            <img
                              src={BURPSUITE}
                              alt="World's No.1 Blockchain Development Company"
                              loading="lazy"
                            />
                          </div>
                          <span>Burp Suite</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </article>
  );
};

export default LandingTechStack;
